
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Divider, Pagination } from "antd";

import CreateUserReport from './EachUser/eachUser';

import "./users.scss";

class ActiveJobsList extends Component{
    constructor(props) {
        super(props)

        let UsersReportList=[
            {
                name:'john@cbs.com',
                storage: '10 GB',
                source: 'CBS',
                activeDate: '06/03/2001',
                status: 'Active',
            },
            {
                name:'David@fox.com',
                storage: '2 GB',
                source: 'FOX',
                activeDate: '07/03/2019',
                status: 'Deactivate',
            },
            {
                name:'Mike@CloudFlyer.com',
                storage: '5 GB',
                source: 'CloudFlyer',
                activeDate: '09/12/2000',
                status: 'Active',
            },

        ];
        this.state = {
            UsersReport: UsersReportList,
        }

    }
    render(){
        const UsersTableHeader = <ul>
                                    <li>User Name</li>
                                    <li>Total Usage</li>
                                    <li>Account Name</li>
                                    <li>Registration Date</li>
                                    <li>Status</li>
                                    <li>Detail</li>
                                </ul>

        const ReportList = this.state.UsersReport.map((rl,index)=>{
            return(
                <div>
                    <Divider/>
                    <CreateUserReport 
                        key = {index}
                        name = {rl.name}
                        storage = {rl.storage}
                        source = {rl.source}
                        activeDate = {rl.activeDate}
                        status = {rl.status}
                    />
                </div>
            )
        })
        return(
            <div className="active-jobs-wrapper">
                <div className="header">
                    <h3>Users</h3>
                </div>
                <div className="table-header">
                    {UsersTableHeader}
                </div>
                <div>
                    {ReportList}
                </div>
                <Divider/>
                <div className="page-pagination">
                    <Pagination size="small" total={500} defaultPageSize={10}/>
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(ActiveJobsList)
  );